(function () {
    const checkoutButton = document.querySelector('.cart__checkout-button');
    const stickycheckoutButton = document.querySelector('.sticky_container');
  

        // Создаем наблюдатель
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
            if (!entry.isIntersecting) {
                // Если элемент не виден, добавляем класс active
                stickycheckoutButton.classList.add('active');
            } else {
                // Если элемент виден, убираем класс active
                stickycheckoutButton.classList.remove('active');
            }
            });
        });
        
        
        // Начинаем наблюдение за основным элементом
        if (checkoutButton) {
            observer.observe(checkoutButton);
        }
        const termsCheckbox = document.getElementById("newsletter-checkbox");

        if (termsCheckbox && checkoutButton) {
            // Слушаем изменения чекбокса
            termsCheckbox.addEventListener('change', function() {
                // Если чекбокс отмечен — disabled = false, если нет — true
                checkoutButton.disabled = !this.checked;
            });
        }
  })();

(function () {
    const stickycheckoutButton = document.querySelector('.sticky_add_to_cart');
    
    stickycheckoutButton.addEventListener('click', function () {
        const target = document.querySelector('.cart__footer .cart__blocks_inner'); 
        if (target ) {
            const rect = target.getBoundingClientRect();
            const offset = window.pageYOffset + rect.top - 300; // -300 пикселей вверх
            window.scrollTo({
                top: offset,
                behavior: 'smooth'
            });
        }
    });
})();

